import React from 'react';
import styled from 'styled-components';

import { splitNumberEndingZeros } from '#/lib/display/formatting';

type IColor = 'red' | 'green' | 'white';

type IProps = {
  value: string;
  color: IColor;
};

const Text = styled.span<{ $color: IColor }>`
  font-family: var(--digitsFontFamily);
  color: ${props =>
    props.$color === 'green'
      ? 'var(--green4)'
      : props.$color === 'red'
      ? 'var(--red3)'
      : 'var(--white)'};
`;

const OpaqueText = styled(Text)`
  opacity: ${props => (props.$color === 'white' ? 0.8 : 0.6)};
`;

const NumberColored = ({ value, color }: IProps) => {
  const [core, endingZeros] = splitNumberEndingZeros(value);

  return (
    <>
      <Text $color={color}>{core}</Text>
      {endingZeros && <OpaqueText $color={color}>{endingZeros}</OpaqueText>}
    </>
  );
};

export default NumberColored;
